import React, { Component } from 'react';
import PropTypes from 'prop-types';
// import { Link } from 'react-router-dom';

import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';

import UploadButton from './UploadButton';

import CONSTANTS from '../utils/Constants';

const styles = theme => ({
	bar: {
		top: 'auto',
		bottom: 0,
	},
	regular: {
		minHeight: (theme.spacing.unit * 9)
	},
	positive: {
		backgroundColor: CONSTANTS.COLORS.POSITIVE,
	},
	uncertain: {
		backgroundColor: CONSTANTS.COLORS.UNCERTAIN,
	},
	negative: {
		backgroundColor: CONSTANTS.COLORS.NEGATIVE,
	},
	tip: {
		backgroundColor: CONSTANTS.COLORS.TIP,
	},
	bottomBackground: {
		backgroundColor: theme.palette.background.default,
	},
	gutters: {
		paddingLeft: (theme.spacing.unit * 3.5),
		paddingRight: (theme.spacing.unit * 3.5)
	},
	grow: {
		flex: 1
	},
	rightBtn: {
		marginRight: -1 * theme.spacing.unit
	},
});

class FormFooter extends Component {
	constructor(props) {
		super(props);
		this.emergencyBtn = props.category === "negative" && React.createRef();
	}

	componentDidMount() {
		let simulateClick = el => {
			let event = new MouseEvent('click', {
				bubbles: true,
				cancelable: true,
				view: window
			});
			let canceled = !el.dispatchEvent(event);
		}
		if(this.emergencyBtn && window.location.search === "?call") {
			simulateClick(this.emergencyBtn.current);
		}
	}

	// componentWillUnmount() {
	// }
	// 

	render() {
		let {classes, category, selectFileHandler, attachedCount, disableSubmit} = this.props;
		let emergencyBtn = null;
		let trackerLabel = `Send ${category} Submission`;
		// let emergencyBtn = category === "negative" 
		// 	? (
		// 		<Button
		// 			variant="contained"
		// 			color="primary"
		// 			buttonRef={this.emergencyBtn}
		// 			aria-label="Call 911"
		// 			href={`tel:${CONSTANTS.EMERGENCY_NUMBER}`}
		// 			classes={{
		// 				containedPrimary: classes[category]
		// 			}}
		// 			style={{
		// 				marginRight: "1em"
		// 			}}
		// 		>911</Button>
		// 	) : null;

		return (
			<AppBar position="fixed" className={classes.bar} elevation={2} square
				classes={{
					colorPrimary: classes.bottomBackground
				}}>
				<Toolbar
					classes={{
						gutters: classes.gutters,
						regular: classes.regular
					}}>
					{emergencyBtn}
					<UploadButton selectFileHandler={selectFileHandler} count={attachedCount} />
					<div className={classes.grow} />
					<Button
						ga-on="click"
						ga-event-category="WebApp"
						ga-event-action="Button Pressed"
						ga-event-label={trackerLabel}
						disabled={disableSubmit}
						variant="contained"
						color="primary"
						aria-label="send"
						type="submit"
						classes={{
							containedPrimary: classes[category]
						}}
					>Send</Button>
				</Toolbar>
			</AppBar>
		);
	}
}

FormFooter.propTypes = {
	classes: PropTypes.object.isRequired,
	selectFileHandler: PropTypes.func.isRequired,
	attachedCount: PropTypes.number,
	disableSubmit: PropTypes.bool,
	category: PropTypes.string.isRequired
};

export default withStyles(styles)(FormFooter);
